import React from "react";
import "./LoginOrRegister.css";
import { Link } from "react-router-dom";
import BrandLogo from "../../Components/BrandLogo/BrandLogo";

export default function LoginOrRegister() {
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay loginOrRegisterWrapper">
        <BrandLogo />
        <div className="loginOrRegisterBtnsWrapper centeredFlex">
          <Link to="/login" className="goToLoginBtn link">
            ورود
          </Link>
          <Link to="/register" className="goToRegisterBtn link">
            ثبت نام
          </Link>
        </div>
      </div>
    </div>
  );
}
